import { render, staticRenderFns } from "./rulerV.vue?vue&type=template&id=1998367a&scoped=true&"
import script from "./rulerV.vue?vue&type=script&lang=js&"
export * from "./rulerV.vue?vue&type=script&lang=js&"
import style0 from "./rulerV.vue?vue&type=style&index=0&id=1998367a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1998367a",
  null
  
)

export default component.exports